<nz-layout>
  <nz-content>
    <ng-container>
      <app-reusable-table title="Medical History" [columns]="['Description']" [rowFields]="['description']"
        [data]="medicalAlerts" [addComponent]="addComp" [deleteFun]="deleteFun" [isLoading]="isLoading"
        [openModalFun]="openModalFun" [isPreview]="false" [addPermissions]="['a-mhi']" />
    </ng-container>
  </nz-content>
</nz-layout>